const isValidTime = (str: string) => /^([0-1]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(str);

export default isValidTime;
